import React from "react";
import { useLoadableSlice } from "../../store/shared";

import { loadAttributes } from "../../store/attributes/attributes.actions";
import { getAccountSettings } from "../../store/root.selectors";

export const withAttributesGuard = (Component) => () => {
  const attributes = useLoadableSlice(loadAttributes(), getAccountSettings);
  if (attributes === null) {
    return null;
  }

  return <Component />;
};
